"use client"

import { useState } from "react"
import { X, Clock, Plus } from "lucide-react"
import { formatDistanceToNow, format } from 'date-fns';


const SyncedHistoryModal = ({ results, isOpen, onClose, onSubmit }) => {
  
  if (!isOpen) return null

  
  const handleClose = () => {
    onClose()
  }

  
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-4xl w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-t-3xl">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
              <Clock className="w-5 h-5 text-white" />
            </div>
            <h2 className="text-xl font-bold">Sync History</h2>
          </div>
          <button onClick={handleClose} className="p-2 hover:bg-white/20 rounded-xl transition-colors duration-200">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="overflow-x-auto rounded-lg shadow  max-h-[70vh] overflow-y-auto">
          <table className="min-w-full table-auto text-sm text-left text-gray-700">
            <thead className="bg-gray-100 text-xs uppercase font-semibold text-gray-600">
              <tr>
                <th className="px-4 py-3">Minutes(Sent)</th>
                <th className="px-4 py-3">Date</th>
                <th className="px-4 py-3">Count</th>
                <th className="px-4 py-3">Type</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {results.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50 transition">
                  <td className="px-4 py-3 font-medium text-gray-900">{item.minutes_ago}</td>
                  <td className="px-4 py-3">
                    {formatDistanceToNow(new Date(item.timestamp), { addSuffix: true })} 
                    <span className="text-gray-400 text-xs ml-1">
                      ({format(new Date(item.timestamp), 'MMM dd yyyy hh:mm a')})
                    </span>
                  </td>
                  <td className="px-4 py-3">{item.found_alerts_count}</td>
                  <td className="px-4 py-3">{item.data_type ?? 'Alerts'}</td>
                </tr>
              ))}
            </tbody>
          </table>
         </div>
        

          {/* Footer */}
          <div className="flex gap-4 mt-8 p-5">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 px-6 py-4 border-2 border-gray-300 text-gray-700 rounded-2xl hover:bg-gray-50 transition-colors duration-200 font-medium"
            >
              Cancel
            </button>
           
          </div>
        
      </div>
    </div>
  )
}

export default SyncedHistoryModal
